import styled from 'styled-components'
import { customTheme } from '../../../styles/theme'

interface IItemProps {
  selected: boolean;
  bg?: string;
  borderColor?: string;
  color?: string;
}

export const Container = styled.div`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 30px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Title = styled.h2`
  margin-bottom: 15px;


  display: flex;
  align-items: flex-end;

  font-weight: bold;
  font-size: 40px;
  line-height: 100%;
  color: #FFFFFF;
`

export const Points = styled.div`
  margin-bottom: 15px;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  color: #FFFFFF;
`

export const Description = styled.div`
  max-width: 516px;
  margin-bottom: 15px;
  word-wrap: break-word;

  font-size: 16px;
  line-height: 24px;
  color: #FFFFFF;
`

export const Choices = styled.div`
  margin-top: 3%;
  font-size: 16px;
  line-height: 24px;
  color: #FFFFFF;
`

export const Options = styled.div`
  margin-top: 20px;
  max-width: 75%;

  display:  flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    max-width: 100%;
  }
`

export const Item = styled.button<IItemProps>`
  padding: 5px 17px 5px 10px;
  width: 100%;
 
  border-radius: 5px;
  background: ${({ selected, bg }) => selected ? bg : '#fff'};
  color: ${({ selected, color, bg }) => selected ? color : bg};
  border: 2px solid ${({ borderColor }) => borderColor};
  font-size: 14px;
  line-height: 21px;
  cursor: pointer;
  text-align: left;

  & + & {
    margin-top: 15px;
  }
`

export const OptContent = styled.div`
  overflow: hidden;
`

export const OptWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;
`

export const OpenButton = styled.button<any>`
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  height: 35px;
  width: 14px;

  >.right {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 0 5px 8.7px;
    border-color: transparent transparent transparent ${({ selected, color, bg }) => selected ? color : bg};
  }

  >.bottom {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8.7px 5px 0 5px;
    border-color: ${({ selected, color, bg }) => selected ? color : bg} transparent transparent transparent;
  }
`
